import type { FC, ReactNode } from 'react';

interface BalanceItemProps {
  iconSlot: ReactNode;
  amountSlot: ReactNode;
  currencySlot: ReactNode;
  actionSlot: ReactNode;
}
export const BalanceItem: FC<BalanceItemProps> = ({
  iconSlot,
  amountSlot,
  currencySlot,
  actionSlot,
}) => {
  return (
    <div className="bg-back300 flex justify-between gap-2 rounded-lg px-4 py-2">
      <div className="flex items-center gap-1">
        <div className="size-4">{iconSlot}</div>
        <div className="flex flex-col">
          <div className="text-text300 text-sm font-semibold">{amountSlot}</div>
          <div className="text-secondary text-2xs">{currencySlot}</div>
        </div>
      </div>
      <div className="flex items-center justify-center">{actionSlot}</div>
    </div>
  );
};
